import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'x-order-is-partially-paid-dialog',
  templateUrl: './order-is-partially-paid-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderIsPartiallyPaidDialogComponent {
  constructor(public dialogRef: MatDialogRef<OrderIsPartiallyPaidDialogComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
